var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('AppBar',{on:{"navigationStatus":_vm.navigationStatus}}),_c('NavigationDrawer',{attrs:{"navigationStatus":_vm.navigationStatus,"the-drawer":_vm.theDrawer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }